import type { ValueOf } from 'type-fest';
import type { ClubLoadIndicator } from '../club-load-indicator/club-load-indicator.types';
import type { OpenStatus } from '../open-status/open-status.types';

export const backgrounds = {
  light: 'light',
  fixed: 'fixed',
} as const;

export type LoadAndOpenStatus = {
  background?: ValueOf<typeof backgrounds>;
  loadFactor?: ClubLoadIndicator['loadFactor'];
  loadIndicator: ClubLoadIndicator;
  openStatus?: OpenStatus;
};
